// ============================================================================
// Adds custom increment functionality
// ============================================================================
// TODO: It would be nice if this didn't live here in theme.js

// -------------------------------------
// Dependencies
// -------------------------------------

import $ from 'jquery';


// -------------------------------------
// Hooks
// -------------------------------------

$(document).ready(function() {
    const $formInput = $('.form__input[type="number"]');

    if ($formInput) {
        $('.form__increment').on('click', function() {

            var $button = $(this);
            var oldValue = $button.parent().find('input').val();

            $button.parent().find('input').focus();

            if ($button.hasClass('form__increment--up')) {
                var newVal = parseFloat(oldValue) + 1;
            }
            else {
                // Don't allow decrementing below zero
                if (oldValue > 1) {
                    var newVal = parseFloat(oldValue) - 1;
                } else {
                    newVal = 1;
                }
            }

            $button.parent().find('input').val(newVal).trigger('change');
            $('button[name=update_cart]').prop('disabled', false);

        });
    }
});
